import { Button } from "@/components/atoms/button";
import { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
  };
  illustration?: {
    src: string;
    alt: string;
  };
}

export function EmptyState({
  title,
  description,
  icon: Icon,
  action,
  illustration,
}: EmptyStateProps) {
  return (
    <div className="min-h-[200px] sm:min-h-[250px] flex flex-col items-center justify-center text-center">
      {illustration ? (
        <div className="w-32 h-32 sm:w-40 sm:h-40 mb-4 sm:mb-6 mt-6 sm:mt-10">
          <img
            src={illustration.src}
            alt={illustration.alt}
            className="w-full h-full object-contain"
          />
        </div>
      ) : Icon ? (
        <div className="w-12 h-12 sm:w-16 sm:h-16 mb-4 sm:mb-6 text-gray-400">
          <Icon className="w-full h-full" />
        </div>
      ) : null}

      <h3 className="text-lg sm:text-xl font-medium text-gray-900 mb-2 px-2">
        {title}
      </h3>
      {description && (
        <p className="text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 max-w-sm sm:max-w-md px-2">
          {description}
        </p>
      )}
      {action && (
        <Button
          onClick={action.onClick}
          className="bg-indigo-600 text-white hover:bg-indigo-700 text-sm sm:text-base px-4 sm:px-6 py-2 sm:py-2.5"
          disabled={action.disabled}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
